import React from 'react'

const Store = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <mask
            id="prefooter-store-mask"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="9"
            y="8"
            width="32"
            height="34"
        >
            <path
                d="M40.2861 8.38672H9.71484V41.6163H40.2861V8.38672Z"
                fill="white"
            />
        </mask>
        <g mask="url(#prefooter-store-mask)">
            <path
                d="M37.468 20.0313C32.2708 13.8772 25.7711 8.9459 24.6546 8.9459C23.5381 8.9459 18.6999 14.0367 17.5833 15.3127C17.3175 15.6184 17.0384 15.9773 17.1447 16.3628C17.251 16.7881 17.7694 17.0008 18.1948 16.8944C18.6068 16.7881 18.9125 16.3893 19.0587 15.9773C19.1917 15.5652 19.1917 15.1266 19.1917 14.7013C19.1917 13.9171 19.7366 9.39782 19.0322 8.97248C18.8062 8.85285 14.061 9.01236 13.968 9.1054C13.8616 9.21173 13.8616 15.007 14.0477 18.0641C14.1009 19.1009 10.4988 22.0251 10.2994 22.7295C10.1532 23.2346 10.7115 35.4631 10.9773 40.7134C10.9773 40.9394 20.4544 40.833 20.5474 40.74C20.6405 40.647 20.6272 35.7423 20.2683 32.406C20.2683 32.2598 20.2284 32.1003 20.3082 31.9674C20.4278 31.7281 20.7734 31.7015 21.0525 31.7015C23.7109 31.7281 26.356 31.861 28.9878 32.087C29.1738 32.087 29.3865 32.1269 29.5194 32.2598C29.6258 32.3661 28.2168 40.4742 28.8283 40.8065C29.4397 41.1388 38.4648 41.1786 38.9566 40.7134C39.1161 40.5672 39.9402 23.4739 39.7143 23.2612C39.6345 22.9422 37.4945 20.0047 37.4945 20.0047"
                stroke="#686058"
                strokeWidth="1.4659"
                strokeMiterlimit="10"
            />
        </g>
    </svg>
)

export default Store
